import { useState } from "react";
import { Image as ImageIcon, X } from "lucide-react";

// Image / multi-image upload control (Bootstrap). uploadImage(file) -> public URL.
export default function ImageInput({
  field,
  value,
  setValue,
  uploadImage,
  invalid,
}) {
  const multi = field.type === "image_multi";
  const max = multi ? field.maxItems || 4 : 1;
  const urls = multi
    ? Array.isArray(value)
      ? value
      : []
    : value
      ? [value]
      : [];
  const [busy, setBusy] = useState(false);

  const add = (url) => {
    if (multi) {
      if (urls.length >= max) return;
      setValue([...urls, url]);
    } else {
      setValue(url);
    }
  };
  const removeAt = (u) => {
    if (multi) setValue(urls.filter((x) => x !== u));
    else setValue(undefined);
  };
  const onFiles = async (e) => {
    const files = [...e.target.files].slice(0, max);
    setBusy(true);
    for (const file of files) {
      try {
        add(await uploadImage(file));
      } catch (_) {}
    }
    setBusy(false);
    e.target.value = "";
  };

  return (
    <div
      className={
        "border fb-dashed rounded p-3 " + (invalid ? "border-danger" : "")
      }
    >
      <label className="fb-pick d-inline-flex align-items-center gap-1 px-3 py-2 rounded bg-primary-subtle text-primary fw-medium small">
        <ImageIcon size={15} /> Choose image{multi ? "s" : ""}
        <input
          type="file"
          accept="image/*"
          multiple={multi}
          className="d-none"
          onChange={onFiles}
        />
      </label>
      <span className="small text-secondary ms-2">
        JPG · PNG · WEBP{multi ? ` · up to ${max}` : ""}
      </span>

      {busy && <p className="small text-secondary mt-2 mb-0">Uploading…</p>}

      {urls.length > 0 && (
        <div className="d-flex flex-wrap gap-2 mt-3">
          {urls.map((u) => (
            <div key={u} className="position-relative">
              <img src={u} alt="" className="fb-thumb rounded border" />
              <button
                type="button"
                onClick={() => removeAt(u)}
                className="fb-thumb-x bg-dark text-white"
              >
                <X size={11} />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
